module.exports = __webpack_public_path__ + "static/media/logo128.52a906c5.png";